import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@mantine/core';

const LanguageSelector = () => {
    const { i18n } = useTranslation();

    const languages = [
        { value: 'en', label: 'English' },
        { value: 'ja', label: '日本語' }
    ];

    const selectedLanguage = localStorage.getItem("language");

    useEffect(() => {
        if (selectedLanguage) {
            i18n.changeLanguage(localStorage.getItem("language"));
        }
    }, [selectedLanguage, i18n]);

    return (
        <Select
            value={i18n.language}
            onChange={(value) => { i18n.changeLanguage(value); localStorage.setItem("language", value); }}
            data={languages}
            style={{ width: '120px' }}
        />
    );
};

export default LanguageSelector;